import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import useDropdown from 'Hooks/useDropdown';

import SearchIcon from 'Assets/icons/search.svg';
import XMarkIcon from 'Assets/icons/xmark.svg';

export default function TableSearchModal({
    id,
    value,
    onChange,
    onClear,
    placeholder = $t('Search…'),
    headerText = $t('Search'),
    customIconStyle = '',
    closeOnAction = true,
    isActive = false,
    onApply = null,
}) {
    const { triggerRef, dropdownRef, isOpen, close, toggle } = useDropdown();
    const inputEl = useRef();

    useEffect(() => {
        if (isOpen) inputEl.current?.focus();
    }, [isOpen]);

    const handleClear = () => {
        typeof onClear === 'function' && onClear();
        if (closeOnAction) close();
    };

    const onSearch = () => {
        if (typeof onApply === 'function') {
            onApply();
        }
        close();
    };

    return (
        <div>
            <button
                type="button"
                aria-controls={id}
                className={`table__icon-btn ${customIconStyle} ${isActive ? '!tw-bg-green-500 !tw-border-green-500' : 'secondary'}`}
                ref={triggerRef}
                onClick={toggle}
            >
                <SearchIcon className="tw-w-3.5 tw-h-3.5" />
            </button>
            {createPortal(
                <div id={id} className={`table__filter-modal${isOpen ? '' : ' hidden'}`} ref={dropdownRef} style={{ zIndex: 1000 }}>
                    <button type="button" className="table__filter-modal__close-btn" onClick={close}>
                        <span aria-hidden="true">
                            <XMarkIcon className="tw-w-2.5 tw-h-2.5" />
                        </span>
                    </button>
                    <div className="tw-p-4 tw-w-80">
                        <div className="table__filter-modal__title">{headerText}</div>
                        <input
                            type="text"
                            className="input text-input !tw-bg-white tw-text-xs tw-h-8 tw-w-full tw-mt-3"
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    onSearch();
                                }
                            }}
                            placeholder={placeholder}
                            ref={inputEl}
                        />
                        <div className="tw-flex tw-justify-end tw-pt-3">
                            <button type="button" className="tw-mr-2" onClick={handleClear}>
                                {$t('Clear')}
                            </button>
                            {!!onApply && (
                                <button type="button" className="table__filter-modal__apply-btn" onClick={onSearch}>
                                    {$t('Apply')}
                                </button>
                            )}

                            {!onApply && (
                                <button type="button" className="table__filter-modal__apply-btn" onClick={close}>
                                    {$t('Close')}
                                </button>
                            )}
                        </div>
                    </div>
                </div>,
                document.body,
            )}
        </div>
    );
}
